<img class="loading-icon {{ size() }}" src="/apps/crm-app/browser/assets/img/loading_icon.png" />
